import { getSessionToken, isTokenExpired } from "@/lib/auth/token-manager";
import { isMockAuthEnabled } from "@/components/providers/mock-auth-provider";

export function useReturningUser(): { isLikelyReturningUser: boolean } {
  if (isMockAuthEnabled()) {
    return { isLikelyReturningUser: true };
  }

  const token = getSessionToken();
  return { isLikelyReturningUser: !!token && !isTokenExpired(token) };
}
